import React,{ useState,useRef } from 'react'
import MicroModal from 'micromodal'
import Modal from '../../common/modal/Modal'
import ResponseMessage from '../../common/modal/ResponseMessage'
import { useEffect } from 'react'
import { performRequest } from '../../common/utils'

const GroupLink = ({ groupDetails }) => {
  const [ isRequesting, setIsRequesting ] = useState( false )
  const [ responseMessage, setResponseMessage ] = useState()
  const [ searchValue, setSearchValue ] = useState('')
  const [ searchResponse, setSearchResponse ] = useState()
  const [ selectedGroup, setSelectedGroup ] = useState()
  const [ overrideSync, setOverrideSync ] = useState({
    checkbox: false,
    visibility: false
  })

  const inputRef = useRef()

  let debounceTimer

  MicroModal.init()

  const openModal = () => {
    MicroModal.show('msync-group-link-modal')
  }
    
  useEffect(() => {
    if( searchValue === '' ) return 
    searchGroup()
  }, [ searchValue ])

  useEffect(()=>{
    if( !selectedGroup ) return
    inputRef.current.value = selectedGroup?.post_title
  }, [ selectedGroup ])

  const searchGroup = async () => {
    const formData = new FormData()
    formData.append('action', 'msync_link_search_group_from_team')
    formData.append('search_value', searchValue )

    try {
      const request = await performRequest( msyncCsvImport.url, formData )
      
      const res = await request.json()

      if( !res.success ) {
        throw new Error(res.message)
      }

      setSearchResponse(res.message)
    } catch ( error ) {
      setResponseMessage({
        type: 'error',
        message: error 
      })
    }
  }
  
  const handleChange = (e) => {
    clearTimeout( debounceTimer )
    
    debounceTimer = setTimeout(()=>{
      const searchVal = e.target.value
      
      setSearchValue( searchVal )
    }, 1000)
  }

  const handleSelectedGroup = ( group ) => {
    setSelectedGroup( group )
    setSearchResponse()
    setResponseMessage()
  }

  const linkGroup = async() => {

    if( !selectedGroup ){
      setResponseMessage({
        type:'error',
        message:'Please search and select a LearnDash Group'
      })
      return
    }

    const formData = new FormData()
    formData.append('action', 'msync_link_group_from_team')
    formData.append('group_id', selectedGroup?.ID )
    formData.append('team_id', groupDetails?.team_id)
    formData.append('override_sync', overrideSync.checkbox)
    
    try {
      setIsRequesting( true )
      const request = await performRequest( msyncCsvImport.url, formData )
      
      const res = await request.json()
  
      if( !res.success ) {
        throw new Error(res.message)
      }

      setResponseMessage({
        type: 'success',
        message: res.message 
      })

      location.assign( msyncCsvImport.current_url )
    } catch ( error ) {

      if( error.message.includes('currently connected')){
        setOverrideSync( (prev) => ({
          ...prev,
          visibility: true,
        }))
      }
      setResponseMessage({
        type: 'error',
        message: `${error}`
      })
    } finally {
      setIsRequesting( false )
    }
  }

  const handleCheckBox = () => {

    setOverrideSync((prev) => ({
      ...prev,
      checkbox: !prev.checkbox
    }))
  }

  return (
    <>
      <div className='msync-team-group-link-unlink'>
          <span>No synced group</span>
          <button type='button' className='msync-button msync-outline-primary-button' onClick={openModal}>Create New</button>
        </div>

        <Modal modalId="msync-group-link-modal" buttonTitle="">
          <header className="modal__header">
              <h2 className="modal__title">Link LearnDash Group to Team</h2>
              <button type='button' className="modal__close" aria-label="Close modal" onClick={()=>MicroModal.close('msync-group-link-modal')}></button>
          </header>
          <main className="modal__content">
            { responseMessage && <ResponseMessage response={ responseMessage } /> }

            <div className="msync-search-group-container">
              <div className='msync-search-group-input'>
                <label htmlFor="msync-link-group-name">Group Name</label>
                <input type="text" id="msync-link-group-name" onChange={(e) => handleChange(e)} ref={inputRef}/>
              </div>
              <div className='msync-search-group-results'>
                {
                  searchResponse && searchResponse.map((group, index) => (
                    <span key={index} onClick={()=>handleSelectedGroup(group)} >{`${group.post_title} (#${group.ID})`}</span>
                  ))
                }
              </div>
              {
                overrideSync.visibility && (
                  <div className='msync-search-group-override-sync'>
                    <input type="checkbox" id="msync-link-override-sync" onClick={handleCheckBox} />
                    <label htmlFor="msync-link-override-sync">Override Link: Remove the selected Group synced from the other Team and use this current Team instead.</label>
                  </div>
                )
              }
            </div>
          </main>
          <footer className="modal__footer">
            <button className="msync-button msync-button-md primary-color" data-micromodal-close aria-label="Close this dialog window">Cancel</button>
            <button type='button' className="msync-button msync-button-md msync-filled-primary-button" onClick={linkGroup} disabled={isRequesting}>
              { isRequesting ? 'Linking...' : 'Link Group' }
            </button>
          </footer>
        </Modal>
    </>
  )
}

export default GroupLink